// Layer ids shared between the layer-rendering components and the click router —
// centralised here so the two sides can never drift (a renamed id in one file
// silently breaking `queryRenderedFeatures` in the other).

export const BORDER_LINE_ID = 'ed-border-line'
/** The standard halo band, mounted directly below `BORDER_LINE_ID`. */
export const BORDER_HALO_ID = 'ed-border-halo'
export const BORDER_HIGHLIGHT_ID = 'ed-border-highlight'
export const SUBAREA_LINE_ID = 'ed-subarea-line'
export const SUBAREA_HIGHLIGHT_ID = 'ed-subarea-highlight'
export const FORBIDDEN_FILL_ID = 'ed-forbidden-fill'
export const FORBIDDEN_LINE_ID = 'ed-forbidden-line'
export const FORBIDDEN_HIGHLIGHT_ID = 'ed-forbidden-highlight'

/** One combined hit layer for border+subarea+forbidden, queried together —
 *  feature `properties.kind` says which. Feature order within the collection
 *  is subarea, then forbidden, then border, so an overlap resolves the same
 *  top-to-bottom priority the old canvas's paint order gave borders. */
export const GROUND_HIT_ID = 'ed-ground-hit'

export const LINES_CASING_ID = (style: string) => `ed-lines-${style}-casing`
export const LINES_ID = (style: string) => `ed-lines-${style}`
export const LINES_HIT_ID = 'ed-lines-hit'

export const DRAFT_POLYGON_FILL_ID = 'ed-draft-polygon-fill'
export const DRAFT_POLYGON_LINE_ID = 'ed-draft-polygon-line'
export const DRAFT_LINE_CASING_ID = 'ed-draft-line-casing'
export const DRAFT_LINE_ID = 'ed-draft-line'

export const PARCEL_FILL_ID = 'ed-parcel-fill'
export const PARCEL_LINE_ID = 'ed-parcel-line'
